import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=6b4f5b76&scoped=true"
import script from "./myOrder.vue?vue&type=script&lang=js"
export * from "./myOrder.vue?vue&type=script&lang=js"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=6b4f5b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f5b76",
  null
  
)

export default component.exports